var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditButtonGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8367 7.5049C18.5133 7.18161 18.0747 7 17.6175 7C17.1602 7 16.7217 7.18161 16.3983 7.5049L7.50527 16.3979C7.18184 16.7212 7.0001 17.1598 7 17.6171V22.1291C7 22.6094 7.39059 23 7.87085 23L21.6613 22.9991C21.89 22.9991 22.1093 22.9083 22.271 22.7466C22.4327 22.5849 22.5236 22.3656 22.5236 22.1369C22.5236 21.9082 22.4327 21.6889 22.271 21.5272C22.1093 21.3655 21.89 21.2747 21.6613 21.2747H14.8221L22.4951 13.6017C22.8184 13.2783 23 12.8398 23 12.3825C23 11.9253 22.8184 11.4867 22.4951 11.1633L18.8367 7.5049ZM12.3838 21.2747L21.2759 12.3825L17.6175 8.72409L8.72446 17.6171V21.2747H12.3838Z",
    fill: "#071E0D",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButtonGrey);
export default __webpack_public_path__ + "static/media/editButtonGrey.a90731c29691d52aa5d3a0dc8ca67b5f.svg";
export { ForwardRef as ReactComponent };